export default "__VITE_ASSET__pfkb2Nkm__"